<script>
import {
  CloseOutlined,
  EditOutlined,
  UpOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  DeleteOutlined,
  CopyOutlined,
} from '@ant-design/icons-vue';
import bem from '@/utils/bem';
import {
  generateMjml,
  generateColumns,
  generateHeading,
  generateText,
  generateSpace,
  generateSeparator,
  generateButton,
  generateFrameBlock,
  generateHeader,
  generateCustomHeader,
  generateFooter,
  generateCustomFooter,
  generateConcierge,
  generateImage,
  generateInvoice,
  generateProofBlock,
  generatePreFooter,
  generateIconsBlock,
} from '@/utils/mjmlGenerate';
import { v4 as uuidv4 } from 'uuid';
import { mapActions, mapState } from 'vuex';
import ModalWrapper from '@/components/modals/Modal-wrapper.vue';
import VariablePopup from '@/pages/settings/emailsTab/Variable-popup.vue';
import ComponentIcons from '@/pages/settings/emailsTab/Component-icons.vue';
import ContentBlock from '@/pages/settings/emailsTab/Content-block.vue';
import ContentEditor from '@/pages/settings/emailsTab/Content-editor.vue';
import EmailFrameSelector from '@/pages/settings/emailsTab/Email-Frame-Selector.vue';
import CustomHeaderEditor from '@/pages/settings/emailsTab/CustomHeader-editor.vue';
import CustomFooterEditor from '@/pages/settings/emailsTab/CustomFooter-editor.vue';
import UploadImages from '@/components/ux/upload/Upload-images.vue';
import {
  CREATE_NEW,
  TYPES,
  REQUIRED_FIELDS,
  LINK_LIST,
  CONSTANTS,
  EXAMPLES,
  COMPONENTS,
  STYLE_LIST,
  COMMERCIAL_TYPES,
} from '@/pages/settings/emailsTab/constants';

const b = bem('emails-editor');
export default {
  components: {
    VariablePopup,
    ComponentIcons,
    ContentBlock,
    CloseOutlined,
    EditOutlined,
    UpOutlined,
    DownOutlined,
    LeftOutlined,
    RightOutlined,
    DeleteOutlined,
    CopyOutlined,
    ModalWrapper,
    ContentEditor,
    EmailFrameSelector,
    CustomHeaderEditor,
    CustomFooterEditor,
    UploadImages,
  },
  data() {
    return {
      textPopup: null,
      sendEmailValue: '',
      sections: [],
      error: null,
      selectedNewSection: null,
      selectedNewComponent: null,
      cords: null,
      isOnArea: false,
      newImgVisible: null,
      addFrameIndex: null,
      columnToContent: null,
      file: null,
      editColumnId: null,
      editSectionId: null,
      editContent: null,
      editCustomHeader: null,
      editCustomFooter: null,
      isImageWithLink: false,
      imageLink: '',
      subjectCursorPos: null,
      CREATE_NEW,
      TYPES,
      EXAMPLES,
      COMPONENTS,
      STYLE_LIST,
      COMMERCIAL_TYPES,
    };
  },
  props: {
    selectedEmail: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    emailName: {
      type: String,
      required: true,
    },
    editIsReminder: {
      type: Boolean,
      required: false,
      default: false,
    },
    editIsDefault: {
      type: Boolean,
      required: false,
      default: false,
    },
    editSubject: {
      type: String,
      required: true,
    },
    editType: {
      type: Object,
      required: false,
      default: null,
    },
    frameIds: {
      type: Array,
      required: true,
    },
    framesCount: {
      type: Number,
      required: false,
      default: 0,
    },
    clearEditStatus: {
      type: Function,
      required: false,
      default: () => {},
    },
    updateToggle: {
      type: Function,
      required: false,
      default: () => {},
    },
    changeType: {
      type: Function,
      required: false,
      default: () => {},
    },
    changeText: {
      type: Function,
      required: false,
      default: () => {},
    },
    updateFrames: {
      type: Function,
      required: false,
      default: () => {},
    },
    startSections: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    updateCommercialType: {
      type: Function,
      required: false,
      default: () => {},
    },
    forCustomerCategoryId: {
      type: Object,
      required: true,
      default: COMMERCIAL_TYPES[0],
    },
    companies: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    ...mapActions({
      getEmailsAction: 'emails/getEmails',
      createEmailAction: 'emails/createEmail',
      copyEmailAction: 'emails/copyEmail',
      changeEmailAction: 'emails/changeEmail',
      deleteEmailAction: 'emails/deleteEmail',
      getPreviewEmailAction: 'emails/getPreviewEmail',
      clearPreviewEmailAction: 'emails/clearPreviewEmail',
      sendPreviewEmailAction: 'emails/sendPreviewEmail',
      uploadEmailImageAction: 'emails/uploadEmailImage',
      clearEmailImageAction: 'emails/clearEmailImage',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    change({ target: { value } }, type) {
      this.changeText(type, value);
    },
    updateType(type) {
      this.changeType(TYPES.find((itm) => itm.value === type));
    },
    onChangeSubject(e) {
      const {
        target: {
          value,
          selectionStart,
        },
      } = e;
      this.changeText('editSubject', value);

      if (selectionStart >= 2) {
        const twoCharsBefore = value.substr(selectionStart - 2, 2);
        if (twoCharsBefore === '{{') {
          this.subjectCursorPos = selectionStart;
          e.target.blur();
          this.textPopup = 'variable';
        }
      }
    },
    saveVariable(popupTextValue, popupSelectorValue) {
      if (this.textPopup === 'variable') {
        this.textPopup = null;
        const pos = this.subjectCursorPos;
        if (pos !== null) {
          const before = this.editSubject.substring(0, pos);
          const after = this.editSubject.substring(pos);
          this.changeText('editSubject', `${before}${popupSelectorValue}}}${after}`);
          this.subjectCursorPos = null;
        } else {
          this.changeText('editSubject', `${this.editSubject}${popupSelectorValue}}}`);
        }
      }
    },
    closeVariable() {
      this.textPopup = null;
      const pos = this.subjectCursorPos;
      if (pos !== null) {
        const before = this.editSubject.substring(0, pos - 2);
        const after = this.editSubject.substring(pos);
        this.changeText('editSubject', `${before}${after}`);
        this.subjectCursorPos = null;
      } else {
        this.changeText('editSubject', this.editSubject.slice(0, -2));
      }
    },
    getLinks() {
      const { path } = this.selectedEmail || {};

      const fields = REQUIRED_FIELDS[path];

      const { links = [] } = fields || {};

      const filterLinks = LINK_LIST
        .filter((link) => !(links || [])
          .some((lnk) => lnk.value === link.value));

      return [...(links || []), ...filterLinks];
    },
    getConstants() {
      const { path } = this.selectedEmail || {};

      const fields = REQUIRED_FIELDS[path];

      const { constants = [] } = fields || {};

      const filterConstants = CONSTANTS
        .filter((constant) => !(constants || [])
          .some((con) => con.value === constant.value));

      return [...(constants || []), ...filterConstants];
    },
    generateContent(content, contentId) {
      const { id, text } = content;

      switch (id) {
        case 'textBlock':
          return {
            text: 'Enter your text',
            style: {
              'font-size': '20px',
              'font-weight': 500,
              'text-align': 'left',
              width: '100%',
              color: '#5F8AA4',
              'line-height': '1.2',
            },
            id,
            contentId,
          };

        case 'HeadingBlock':
          return {
            text: 'Enter Heading',
            style: {
              'font-size': '24px',
              'font-weight': 500,
              'text-align': 'center',
              width: '100%',
              color: '#000',
              'line-height': '1.2',
            },
            id,
            contentId,
          };

        case 'ButtonBlock':
          return {
            text: 'Button',
            style: {
              'font-size': '16px',
              'line-height': '1.2',
              'font-weight': '400',
              'text-align': 'center',
              padding: '12px 60px',
              'border-radius': '12px 3px',
              'background-color': '#ECC486',
              color: '#293241',
              border: 'none',
            },
            id,
            contentId,
          };

        case 'DividerBlock':
          return {
            text: '',
            style: {
              width: '100%',
              padding: '20px 0',
              'border-width': '1px',
              'border-color': '#D7E8F0',
              content: '',
            },
            id,
            contentId,
          };

        case 'SpacerBlock':
          return {
            text: '',
            style: {
              height: '20px',
              content: '',
            },
            id,
            contentId,
          };

        case 'ImageBlock':
          return {
            text: '',
            style: {
              width: '100%',
              'border-radius': '20px 3px',
            },
            id,
            contentId,
          };

        case 'CustomHeader':
          return {
            text: 'Custom Header',
            id,
            contentId,
            logoUrl: 'https://memoya-production.s3.amazonaws.com/default/forever-studios-logo.png',
            logoLink: 'https://foreverstudios.com/',
            showTrackOrder: true,
            showMyAccount: true,
            showCustomLink: true,
            customLinkUrl: 'https://foreverstudios.com/forever-care/',
            customLinkText: 'FOREVER CARE',
          };

        case 'CustomFooter':
          return {
            text: 'Custom Footer',
            id,
            contentId,
            showTopBlock: true,
            topBlockText: 'Explore Exciting Content From Our Team.',
            showBlogButton: true,
            blogButtonText: 'VINTAGE UNIVERSITY BLOG',
            blogButtonUrl: 'https://foreverstudios.com/blog/',
            showSocialLinks: true,
            showFacebook: true,
            facebookUrl: 'https://www.facebook.com/ForeverStudiosFL',
            showTwitter: true,
            twitterUrl: 'https://twitter.com/Forever_studios',
            showInstagram: true,
            instagramUrl: 'https://www.instagram.com/forever_studios/',
            showYoutube: true,
            youtubeUrl: 'https://www.youtube.com/channel/UCgyUMV4HWMx-XasFPTc7cyQ',
            showBottomLinks: true,
            showDigitizeLink: true,
            digitizeLinkText: 'DIGITIZE',
            digitizeLinkUrl: 'https://foreverstudios.com/media-digitizing-service/',
            showEnhanceLink: true,
            enhanceLinkText: 'ENHANCE',
            enhanceLinkUrl: 'https://foreverstudios.com/old-photo-restoration/',
            showPrintLink: true,
            printLinkText: 'PRINT',
            printLinkUrl: 'https://foreverstudios.com/create-photo-art/',
            copyrightText: '© 2025 Legacy Media Group, LLC',
            showPhone: true,
            phoneNumber: '800-916-6076',
            phoneUrl: 'tel:800-916-6076',
            showAddress: true,
            addressText: '1000 Clint Moore Road, Suite 208, Boca Raton, FL 33487, United States',
            addressUrl: 'https://www.google.com/maps/place/1000+Clint+Moore+Rd+%23+208,+Boca+Raton,+FL+33487',
          };

        default:
          return {
            text,
            id,
            contentId,
          };
      }
    },
    parseText(text) {
      const arr = text.split('[[');
      const newString = arr.reduce((acc, item) => {
        const [substring, continueText] = item.split(']]');
        const [linkText, link] = substring.split('|');
        return `${acc}<a href={{${link}}}>${linkText}</a>${continueText}`;
      });
      const newArr = newString.split('<<');
      const finalText = newArr.reduce((acc, item) => {
        const [substring, continueText] = item.split('>>');
        const [linkText, link] = substring.split('|');
        return `${acc}<a href=${link}>${linkText}</a>${continueText}`;
      });
      return finalText;
    },
    generateContentString(content) {
      const {
        text,
        style,
        href,
        id,
        imageUri,
        isImageWithLink,
        imageLink,
      } = content;
      switch (id) {
        case 'textBlock':
          return generateText(this.parseText(text), style);
        case 'HeadingBlock':
          return generateHeading(text, style);

        case 'ButtonBlock':
          return generateButton(style, href, text, this.getLinks());

        case 'DividerBlock':
          return generateSeparator(style);

        case 'SpacerBlock':
          return generateSpace(style);

        case 'ImageBlock':
          return generateImage({
            src: imageUri,
            style,
            isImageWithLink,
            imageLink,
          });

        default:
          return generateText(text || '', style || {});
      }
    },
    generateBigSections(id, data) {
      switch (id) {
        case 'FramesBlock':
          return generateFrameBlock();
        case 'Header':
          return generateHeader();

        case 'CustomHeader':
          return generateCustomHeader(data);

        case 'Footer':
          return generateFooter();

        case 'CustomFooter':
          return generateCustomFooter(data);

        case 'PreFooter':
          return generatePreFooter();

        case 'Icons':
          return generateIconsBlock();

        case 'Concierge':
          return generateConcierge(data);

        case 'ImagesBlock':
          return generateProofBlock();

        case 'InvoiceBlock':
          return generateInvoice();

        default:
          return '';
      }
    },
    generateMjmlStrung() {
      const sectionsData = this.sections.map((item, index) => {
        let contentId = null;
        let customHeaderData = null;
        let customFooterData = null;
        const { columns = [], style: sectionStyle = {} } = item || {};
        const columnsData = columns.map((itm) => {
          const { style, content } = itm || {};
          const { id, isMessage } = content || {};

          if (['ImagesBlock', 'FramesBlock', 'Header', 'CustomHeader', 'Icons', 'PreFooter', 'Footer', 'CustomFooter', 'Concierge', 'InvoiceBlock'].includes(id)) {
            contentId = id;
            if (id === 'CustomHeader') {
              customHeaderData = content;
            }
            if (id === 'CustomFooter') {
              customFooterData = content;
            }
          }

          const contextSting = content ? this.generateContentString(content) : '';

          return { style, content: contextSting, ...(isMessage ? { isMessage } : {}) };
        });

        let bigSectionData = columnsData;
        if (contentId === 'CustomHeader') {
          bigSectionData = customHeaderData;
        } else if (contentId === 'CustomFooter') {
          bigSectionData = customFooterData;
        }

        return {
          content: contentId
            ? this.generateBigSections(contentId, bigSectionData)
            : generateColumns(columnsData, index),
          isBigSection: Boolean(contentId),
          style: sectionStyle || {},
        };
      });

      return generateMjml(sectionsData);
    },
    onClickSendEmail() {
      const template = this.generateMjmlStrung();
      const isHasFrameBlock = this.sections.find((item) => item?.columns?.[0]?.content?.id === 'FramesBlock');
      const frameIds = isHasFrameBlock
        ? this.frameIds.filter((item) => item).map(({ value }) => value)
        : [];
      this.sendPreviewEmailAction({
        template, frameIds, email: this.sendEmailValue, subject: this.editSubject,
      });
    },
    checkConstants(template, constants) {
      return (constants || []).reduce((acc, { value, label }) => {
        if (template.includes(`{{${value}}}`)) {
          return acc;
        }
        return [...acc, label];
      }, []);
    },
    checkComponents(sections, components) {
      return (components || []).reduce((acc, { value, label }) => {
        const isUsComponent = sections.some((section) => {
          const { columns } = section;
          return columns.some((column) => {
            const { content } = column;
            return content ? content.id === value : false;
          });
        });

        if (isUsComponent) {
          return acc;
        }

        return [...acc, label];
      }, []);
    },
    onClickSave() {
      const { path, id } = this.selectedEmail || {};

      const fields = REQUIRED_FIELDS[path];

      const { constants = [], links = [], components = [] } = fields || {};

      const templateString = this.generateMjmlStrung();

      // const unUsedConstants = this.checkConstants(templateString, constants);
      const unUsedConstants = [];

      // const unUsedLinks = this.checkConstants(templateString, links);
      const unUsedLinks = [];

      // const unUsedComponents = this.checkComponents(sections, components);
      const unUsedComponents = [];

      const isEveryConstants = !constants || !constants.length || !unUsedConstants.length;

      const isEveryLinks = !links || !links.length || !unUsedLinks.length;

      const isEveryComponents = !components || !components.length || !unUsedComponents.length;

      if (!isEveryConstants) {
        this.error = `Need to use constants: ${unUsedConstants.map((label) => label).join(', ')}`;
        return null;
      }

      if (!isEveryLinks) {
        this.error = `Need to use links: ${unUsedLinks.map((label) => label).join(', ')}`;
        return null;
      }

      if (!isEveryComponents) {
        this.error = `Need to use components: ${unUsedComponents.map((label) => label).join(', ')}`;
        return null;
      }

      if (isEveryConstants && isEveryLinks && isEveryComponents) {
        const data = {
          templateStructure: {
            frameIds: this.frameIds.filter((item) => item).map(({ value }) => value),
            sections: this.sections,
            frameList: this.frameIds.filter((item) => item),
          },
          template: templateString,
          name: this.emailName,
          subject: this.editSubject,
          isReminder: this.editIsReminder,
          isDefault: this.editIsDefault,
          type: this.editType.value,
          forCustomerCategoryId: this.forCustomerCategoryId.value,
        };

        if (id) {
          this.changeEmailAction({ ...data, id });
        } else {
          this.createEmailAction(data);
        }
        this.error = null;
      }

      return null;
    },
    onClickPreview() {
      const template = this.generateMjmlStrung();
      const isHasFrameBlock = this.sections.find((item) => item?.columns?.[0]?.content?.id === 'FramesBlock');
      const frameIds = isHasFrameBlock
        ? this.frameIds.filter((item) => item).map(({ value }) => value)
        : [];
      this.getPreviewEmailAction({ template, frameIds });
    },
    onClickClose() {
      this.error = null;
      this.clearEditStatus();
    },
    onMouseDown(e, item, isSection) {
      const { pageX, pageY } = e;

      if (isSection) {
        this.selectedNewSection = item;
        this.cords = { x: pageX - 25, y: pageY + 5 };
      } else {
        this.selectedNewComponent = item;
        this.cords = { x: pageX - 25, y: pageY + 5 };
      }
    },
    onMouseMove(e) {
      if (this.selectedNewSection || this.selectedNewComponent) {
        const { x, y } = e;
        this.cords = { x: x - 25, y: y + 5 };
      }

      if (this.editX) {
        this.changeColumnWidth(e);
      }

      if (this.isEditY) {
        this.changeColumnHeight(e);
      }
    },
    onMouseup() {
      if (this.selectedNewSection && !this.isOnArea) {
        this.selectedNewSection = null;
        this.cords = null;
      }

      if (this.selectedNewComponent && !this.isOnArea) {
        this.selectedNewComponent = null;
        this.cords = null;
      }

      if (this.editX) {
        this.editX = false;
      }

      if (this.isEditY) {
        this.isEditY = false;
      }
    },
    changeColumnWidth(e) {
      const { movementX } = e;

      const sectionElement = document.getElementById(`section-${this.editSectionId}`);
      const { clientWidth = 600 } = sectionElement || {};
      const currentSection = this.sections.find((item) => item.id === this.editSectionId);
      const { columns = [] } = currentSection || {};
      const index = columns.findIndex((item) => item.id === this.editColumnId);

      const currentColumn = columns[index];

      const { style: { width } = {} } = currentColumn || {};

      const startWidth = Number(width.slice(0, -1));

      const deltaPercent = (movementX / clientWidth) * 100
        * (this.editX === 'left' ? -1 : 1)
        * (index === 0 || index === columns.length - 1 ? 1 : 2);

      const newWidth = startWidth + deltaPercent;

      const otherWidth = (100 - newWidth) / (columns.length - 1);

      const newColumns = columns.map((item) => {
        const { style: itemStyle, id } = item;
        return {
          ...item,
          style: {
            ...itemStyle,
            width: id === this.editColumnId ? `${newWidth}%` : `${otherWidth}%`,
          },
        };
      });

      const newSections = this.sections.map((item) => {
        if (item.id === this.editSectionId) {
          return { ...item, columns: newColumns };
        }
        return item;
      });

      this.sections = newSections;
    },
    changeColumnHeight(e) {
      const { movementY } = e;

      const currentSection = this.sections.find((item) => item.id === this.editSectionId);
      const { columns = [], style: sectionStyle } = currentSection || {};
      const index = columns.findIndex((item) => item.id === this.editColumnId);

      const currentColumn = columns[index];

      const { style, content: columnContent } = currentColumn || {};

      const { 'padding-top': paddingTop, 'padding-bottom': paddingBottom } = style;

      const { style: cStile } = columnContent || {};

      const { height } = cStile || {};

      const startHeight = columnContent ? Number((height || '').slice(0, -2)) : 0;
      const startPadding = (Number((paddingTop || '').slice(0, -2)) + Number((paddingBottom || '').slice(0, -2))) / 2;

      const newHeigh = startHeight + movementY;

      const newPadding = startPadding + (movementY / 2);

      const newColumns = columns.map((item) => {
        const { style: itemStyle, content } = item;
        const { style: contentStyle, id: idContent } = content || {};

        return {
          ...item,
          style: {
            ...itemStyle,
            ...(idContent !== 'ImageBlock' ? { 'padding-top': `${newPadding}px`, 'padding-bottom': `${newPadding}px` } : {}),
          },
          ...(content && idContent === 'ImageBlock'
            ? { content: { ...content, style: { ...contentStyle, height: `${newHeigh}px` } } }
            : {}
          ),
        };
      });

      const newSections = this.sections.map((item) => {
        if (item.id === this.editSectionId) {
          return {
            ...item,
            columns: newColumns,
            style: { ...sectionStyle },
          };
        }
        return item;
      });

      if (newPadding >= 0) {
        this.sections = newSections;
      }
    },
    handleAreaMouseEnter() {
      if (this.selectedNewSection || this.selectedNewComponent) {
        this.isOnArea = true;
      }
    },
    handleAreaMouseLeave() {
      if (this.isOnArea) {
        this.isOnArea = false;
      }
    },
    onAreaMouseUp() {
      if (this.selectedNewSection) {
        const { blocs } = this.selectedNewSection;
        const sectionId = uuidv4();
        const section = {
          id: sectionId,
          style: { padding: '0' },
          columns: blocs.map(() => ({
            id: uuidv4(),
            content: null,
            style: {
              width: `${100 / blocs.length}%`,
              'padding-left': '5px',
              'padding-right': '5px',
              'padding-top': '5px',
              'padding-bottom': '5px',
            },
          })),
        };
        this.sections = [...this.sections, section];
        this.selectedNewSection = null;
        this.cords = null;
      }

      if (this.selectedNewComponent) {
        const sectionId = uuidv4();
        const columnId = uuidv4();
        const contentId = `${sectionId}_${columnId}`;

        const section = {
          id: sectionId,
          style: { padding: '0' },
          columns: [{
            id: columnId,
            content: this.generateContent(this.selectedNewComponent, contentId),
            style: {
              width: '100%',
              'padding-left': '5px',
              'padding-right': '5px',
              'padding-top': '5px',
              'padding-bottom': '5px',
            },
          }],
        };

        this.sections = [...this.sections, section];
        this.selectedNewComponent = null;
        this.cords = null;
      }
    },
    onSectionMouseUp(e, currentSection) {
      if (this.selectedNewSection) {
        e.stopPropagation();
        const { blocs } = this.selectedNewSection;
        const sectionId = uuidv4();
        const section = {
          id: sectionId,
          style: { padding: '0' },
          columns: blocs.map(() => ({
            id: uuidv4(),
            content: null,
            style: {
              width: `${100 / blocs.length}%`,
              'padding-left': '5px',
              'padding-right': '5px',
              'padding-top': '5px',
              'padding-bottom': '5px',
            },
          })),
        };
        const newSections = [];
        this.sections.forEach((item) => {
          if (item.id === currentSection.id) {
            newSections.push(item);
            newSections.push(section);
          } else {
            newSections.push(item);
          }
        });
        this.sections = newSections;
        this.selectedNewSection = null;
        this.cords = null;
      }
    },
    onColumnMouseUp(e, currentSection, currentColumn) {
      if (this.selectedNewComponent) {
        e.stopPropagation();
        const { id: sectionId } = currentSection;
        const { id: columnId, content: columnContent } = currentColumn;

        if (columnContent) {
          const newSectionId = uuidv4();
          const newColumnId = uuidv4();
          const newContentId = `${newSectionId}_${newColumnId}`;

          const newSection = {
            id: newSectionId,
            style: { padding: '0' },
            columns: [{
              id: newColumnId,
              content: this.generateContent(this.selectedNewComponent, newContentId),
              style: {
                width: '100%',
                'padding-left': '5px',
                'padding-right': '5px',
                'padding-top': '5px',
                'padding-bottom': '5px',
              },
            }],
          };

          const newSections = this.sections.reduce((acc, item) => {
            if (item.id === sectionId) {
              return [...acc, item, newSection];
            }
            return [...acc, item];
          }, []);

          this.sections = newSections;
          this.selectedNewComponent = null;
          this.cords = null;
          return;
        }

        const contentId = `${sectionId}_${columnId}`;

        const content = this.generateContent(this.selectedNewComponent, contentId);

        const { columns } = currentSection;

        const newColumns = columns
          .map((item) => (item.id === columnId ? { ...item, content } : item));

        const newSection = { ...currentSection, columns: newColumns };

        this.sections = this.sections.map((item) => (item.id === sectionId ? newSection : item));
        this.selectedNewComponent = null;
        this.cords = null;
      }
    },
    openModal(id) {
      this.newImgVisible = id;
    },
    changeFrameCount(e) {
      const newItemsCount = e - this.frameIds.length;

      const newItems = newItemsCount > 0
        ? new Array(newItemsCount).fill(null)
        : [];

      const newFrameIds = [...this.frameIds, ...newItems]
        .filter((item, index) => index + 1 <= e);

      this.updateFrames(newFrameIds, e);
    },
    setFrameIndex(index) {
      this.addFrameIndex = index;
    },
    changeItemField(name, value, data) {
      const newSections = this.sections.map((item) => {
        const { columns } = item;
        const newColumns = columns.map((column) => {
          const { content } = column;
          const { contentId } = content;
          if (contentId === data.contentId) {
            return { ...column, content: { ...content, [name]: value } };
          }
          return column;
        });
        return { ...item, columns: newColumns };
      });

      this.sections = newSections;
    },
    setEditColumn(column) {
      this.columnToContent = column;
    },
    clickEditColumn(id, sectionId) {
      this.editSectionId = this.editColumnId === id ? null : sectionId;
      this.editColumnId = this.editColumnId === id ? null : id;
    },
    onClickEditContent() {
      const currentSection = this.sections.find((item) => item.id === this.editSectionId);
      const { columns = [] } = currentSection || {};
      const currentColumn = columns.find((item) => item.id === this.editColumnId);
      const { content } = currentColumn || {};
      if (content?.id === 'ImageBlock') {
        this.file = [content.imageUri];
        this.isImageWithLink = content.isImageWithLink || false;
        this.imageLink = content.imageLink || '';
        this.openModal(content.contentId);
      } else if (content?.id === 'CustomHeader') {
        this.editCustomHeader = content;
      } else if (content?.id === 'CustomFooter') {
        this.editCustomFooter = content;
      } else {
        this.editContent = content;
      }
    },
    setEditXStatus(status) {
      this.editX = status;
    },
    setEditYStatus() {
      this.isEditY = true;
    },
    deleteSection(id) {
      const section = this.sections.find((item) => item.id === id);
      if (section?.columns?.length && section?.columns[0]?.content?.id === 'FramesBlock') {
        this.updateFrames([null, null], this.framesCount);
      }
      this.sections = this.sections.filter((item) => item.id !== id);
    },
    moveSectionDown(currentSection, index) {
      const newSections = this.sections.filter((item) => item.id !== currentSection.id);
      newSections.splice(index + 1, 0, currentSection);
      this.sections = newSections;
    },

    moveSectionUp(currentSection, index) {
      const newSections = this.sections.filter((item) => item.id !== currentSection.id);
      newSections.splice(index - 1, 0, currentSection);
      this.sections = newSections;
    },
    checkIsShowCopy(columns) {
      return columns.every(
        (({ content }) => ![
          'ImagesBlock',
          'FramesBlock',
          'Header',
          'Footer',
          'PreFooter',
          'Icons',
          'Concierge',
          'InvoiceBlock',
        ].includes((content || {}).id)),
      );
    },
    copySection(sectionId) {
      const newSections = [];

      this.sections.forEach((section) => {
        const { id, columns } = section;

        if (id !== sectionId) {
          newSections.push(section);
        } else {
          const newSectionId = uuidv4();

          const newColumns = columns.map((column) => {
            const { content } = column;
            const newColumnId = uuidv4();
            const contentId = `${newSectionId}_${newColumnId}`;
            return {
              ...column,
              id: newColumnId,
              content: { ...content, contentId },
            };
          });

          const newSection = { ...section, id: newSectionId, columns: newColumns };

          newSections.push(section);
          newSections.push(newSection);
        }
      });

      this.sections = newSections;
    },
    addContent(component) {
      const newSections = this.sections.map((section) => {
        const { id: sectionId, columns } = section;
        const newColumns = columns.map((column) => {
          const { id: columnId } = column;
          if (this.columnToContent.id === columnId) {
            const contentId = `${sectionId}_${columnId}`;
            const newContent = this.generateContent(component, contentId);

            return { ...column, content: newContent };
          }
          return column;
        });
        return { ...section, columns: newColumns };
      });

      this.sections = newSections;
      this.columnToContent = null;
    },
    getEditContentData({
      list = [],
      style,
    }) {
      return list.map((item) => {
        const { name, postfix, isCheckbox } = item;
        const value = style[name];
        const newValue = postfix === 'px' ? (value || '').replace('px', '') : (value || '');
        // eslint-disable-next-line no-prototype-builtins
        const checkboxValue = isCheckbox && style.hasOwnProperty(name) && Boolean(value);
        return { ...item, value: isCheckbox ? checkboxValue : newValue };
      });
    },
    getColumn(editSectionId, editColumnId) {
      const section = this.sections.find((item) => item.id === editSectionId);
      if (section) {
        const { columns } = section;
        const column = columns.find((item) => item.id === editColumnId);
        return column;
      }
      return null;
    },
    getEditColumnStyle() {
      const editColumn = this.editSectionId
        ? this.getColumn(this.editSectionId, this.editColumnId)
        : null;
      const { style } = editColumn || {};
      return style;
    },
    saveNewStyle(data) {
      const {
        newStyle,
        newColumnStyle,
        newText,
        newHref,
      } = data;

      const newSections = this.sections.map((section) => {
        if (section.id !== this.editSectionId) {
          return section;
        }

        const { columns } = section;

        const newColumns = columns.map((column) => {
          if (column.id !== this.editColumnId) {
            return column;
          }

          const { content, style: columnStyle } = column;

          const { style } = content;

          return {
            ...column,
            style: {
              ...columnStyle,
              ...newColumnStyle,
            },
            content: {
              ...content,
              style: { ...style, ...newStyle },
              // eslint-disable-next-line no-prototype-builtins
              ...(data.hasOwnProperty('newText') ? { text: newText } : {}),
              // eslint-disable-next-line no-prototype-builtins
              ...(data.hasOwnProperty('newHref') ? { href: newHref } : {}),
            },
          };
        });

        return { ...section, columns: newColumns };
      });

      this.sections = newSections;
      this.editContent = null;
    },
    saveCustomHeader(data) {
      const newSections = this.sections.map((section) => {
        if (section.id !== this.editSectionId) {
          return section;
        }

        const { columns } = section;

        const newColumns = columns.map((column) => {
          if (column.id !== this.editColumnId) {
            return column;
          }

          const { content } = column;

          return {
            ...column,
            content: {
              ...content,
              ...data,
            },
          };
        });

        return { ...section, columns: newColumns };
      });

      this.sections = newSections;
      this.editCustomHeader = null;
    },
    saveCustomFooter(data) {
      const newSections = this.sections.map((section) => {
        if (section.id !== this.editSectionId) {
          return section;
        }

        const { columns } = section;

        const newColumns = columns.map((column) => {
          if (column.id !== this.editColumnId) {
            return column;
          }

          const { content } = column;

          return {
            ...column,
            content: {
              ...content,
              ...data,
            },
          };
        });

        return { ...section, columns: newColumns };
      });

      this.sections = newSections;
      this.editCustomFooter = null;
    },
    closeFrameSelector() {
      this.addFrameIndex = null;
    },
    saveFrame(frame) {
      const frameIds = this.frameIds.map((item, index) => (
        this.addFrameIndex === index ? frame : item
      ));

      this.updateFrames(frameIds, this.framesCount);
      this.addFrameIndex = null;
    },
    onOk() {
      const [file] = this.file;
      if (!file.file) {
        this.afterUploadImage(file.url);
        this.file = null;
        this.newImgVisible = null;
      } else {
        const formData = new FormData();
        formData.append('file', file.file);
        formData.append('folder', 'tmp-email-images');
        this.uploadEmailImageAction(formData);
      }
    },
    afterUploadImage(url) {
      this.sections = this.sections.map((section) => {
        const { columns } = section;
        const newColumns = columns.map((column) => {
          const { content } = column;
          if (content && content.contentId === this.newImgVisible) {
            return {
              ...column,
              content: {
                ...content,
                imageUri: url,
                isImageWithLink: this.isImageWithLink || false,
                imageLink: this.imageLink || '',
              },
            };
          }

          return column;
        });

        return { ...section, columns: newColumns };
      });

      this.cancel();
    },
    cancel() {
      this.file = null;
      this.newImgVisible = null;
      this.isImageWithLink = false;
      this.imageLink = '';
    },
  },
  mounted() {
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseup);
    this.sections = this.startSections || [];
  },
  beforeUnmount() {
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseup);
  },
  computed: {
    ...mapState({
      preview: (state) => state.emails.preview,
      emailImage: (state) => state.emails.emailImage,
    }),
    isHardcodeEmail() {
      return (this.selectedEmail || {}).type === 'hardcode';
    },
    commercialTypesWithCompanies() {
      const companyOptions = this.companies.map((company) => ({
        value: company.id + 2,
        label: company.displayName,
        text: company.displayName,
      }));
      return [...COMMERCIAL_TYPES, ...companyOptions];
    },
  },
  watch: {
    emailImage(newValue, oldVAlue) {
      if ((newValue && !oldVAlue) || newValue?.data?.key !== oldVAlue?.data?.key) {
        const { data: { url } = {} } = newValue || {};
        this.afterUploadImage(url);
      }
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div :class="b('preview-vail')" v-if="preview">
      <div :class="b('preview-block')">
        <div :class="b('preview')" v-html="preview"></div>
        <a-button
          type="primary"
          html-type="button"
          @click="clearPreviewEmailAction()"
        >
          Close
        </a-button>
      </div>
    </div>
    <div :class="b('emails-top-block')">
      <!-- Row 1: All fields in one row -->
      <div :class="b('emails-top-block-row')">
        <div v-if="isHardcodeEmail" :class="b('name-block')">
          <div :class="b('name')">Name:</div>
          <div :class="b('name')">{{emailName}}</div>
        </div>
        <div v-if="!isHardcodeEmail" :class="b('field-inline')">
          <div :class="b('field-label')">Name</div>
          <a-input
            type="text"
            :value="emailName"
            @change="(e) => {change(e, 'emailName')}"
            style="width: 140px"
          />
        </div>
        <div :class="b('field-inline')" v-if="!isHardcodeEmail">
          <div :class="b('field-label')">Type</div>
          <a-select
            style="width: 140px"
            :value="editType"
            :options="TYPES"
            @change="updateType"
          />
        </div>
        <div :class="b('field-inline')" v-if="!isHardcodeEmail">
          <div :class="b('field-label')">Commercial</div>
          <a-select
            style="width: 140px"
            :value="forCustomerCategoryId"
            :options="commercialTypesWithCompanies"
            @change="updateCommercialType"
          />
        </div>
        <div :class="b('field-inline')">
          <div :class="b('field-label')">Reminder</div>
          <a-switch
            :checked="editIsReminder"
            checked-children="Yes"
            un-checked-children="No"
            @click="updateToggle('editIsReminder', !editIsReminder)"
          />
        </div>
        <div :class="b('field-inline')">
          <div :class="b('field-label')">Default</div>
          <a-switch
            :checked="editIsDefault"
            checked-children="Yes"
            un-checked-children="No"
            @click="updateToggle('editIsDefault', !editIsDefault)"
          />
        </div>
        <div :class="b('field-inline')">
          <div :class="b('field-label')">Test Email</div>
          <a-input
            type="text"
            v-model:value="sendEmailValue"
            placeholder="email@test.com"
            style="width: 160px"
          />
        </div>
        <div :class="b('actions-buttons')">
          <a-button
            type="primary"
            size="small"
            @click="onClickSendEmail()"
            :disabled="!sendEmailValue || !editSubject"
          >
            Send
          </a-button>
          <a-button
            type="primary"
            size="small"
            @click="onClickSave()"
            :disabled="!emailName || !editSubject"
          >
            Save
          </a-button>
          <a-button
            type="primary"
            size="small"
            @click="onClickPreview()"
          >
            Preview
          </a-button>
          <a-button
            size="small"
            @click="onClickClose()"
          >
            Close
          </a-button>
        </div>
      </div>

      <!-- Row 2: Subject -->
      <div :class="b('emails-top-block-row', { subject: true })">
        <div :class="b('subject-block')">
          <div :class="b('field-label')">Subject</div>
          <a-textarea
            :value="editSubject"
            :auto-size="{ minRows: 1, maxRows: 6 }"
            @input="(e) => {onChangeSubject(e)}"
            placeholder="Enter subject..."
          />
          <template v-if="textPopup">
            <variable-popup
              :closeVariable="closeVariable"
              :saveVariable="saveVariable"
              :textPopup="textPopup"
              :className="b('variable-popup')"
              :links="getLinks()"
              :constants="getConstants()"
            />
          </template>
        </div>
        <div :class="b('subject-hint')">
          Enter {{'{'+'{' }} to add a variable.<br/>
          To delete, erase from {{'{'+'{' }} to {{'}'+'}'}}.
        </div>
      </div>
    </div>
    <div v-if="error" :class="b('error')">{{error}}</div>
    <div :class="b('editor')">
      <template v-if="newImgVisible">
        <modal-wrapper v-model:show="newImgVisible" width="600px" >
        <div :class="b('modal-content')">
          <div :class="b('modal-title')">Add image</div>
          <div :class="b('uploader-wrap')">
            <upload-images
              v-model:files="file"
              :initial-images="file"
              :is-multiple="false"
            />
          </div>
          <div :class="b('modal-switcher')">
            <a-switch
              style="min-width: max-content"
              checked-children="with link"
              un-checked-children="without link"
              v-model:checked="isImageWithLink"
            />
            <a-input
              v-if="isImageWithLink"
              style="width: 180px"
              placeholder="Link"
              v-model:value="imageLink"
            />
          </div>
          <div :class="b('modal-buttons-wrap')" >
            <a-button
              type="primary"
              html-type="button"
              :disabled="!file || !file.length"
              @click="onOk"
            >
              Add
            </a-button>
            <a-button
              html-type="button"
              @click="cancel"
            >
              Cancel
            </a-button>
          </div>
        </div>
      </modal-wrapper>
      </template>
      <div
        :class="b('portal-block')"
        :style="`top: ${(cords || {}).y}px; left: ${(cords || {}).x}px; `"
        v-if="selectedNewSection || selectedNewComponent"
      >
        <div :class="b('example')" v-if="selectedNewSection">
          <div
            v-for="(itm) in selectedNewSection.blocs"
            :class="b('example-block')"
            :style="{ width: itm.width }"
            :key="`portal ${itm.id} ${itm.width}`"
          />
        </div>
        <div
          :class="b('component-button')"
          v-if="selectedNewComponent"
        >
          <component-icons
            :className="b('component-button-icon')"
            :type="selectedNewComponent.icon"
          />
          {{selectedNewComponent.text}}
        </div>
      </div>
      <div :class="b('editor-controls')">
        <div :class="b('editor-title')">Sections</div>
        <div :class="b('examples')">
          <div
            :class="b('example')"
            v-for="(item) in EXAMPLES"
            :key="item.id"
            @mousedown="(e) => { onMouseDown(e, item, true); }"
          >
            <div
              v-for="(itm) in item.blocs"
              :class="b('example-block')"
              :style="{ width: itm.width }"
              :key="`${itm.id} ${itm.width}`"
            />
          </div>
        </div>
        <div :class="b('editor-title')">Components</div>
        <div :class="b('components')">
          <div
            v-for="(itm) in COMPONENTS"
            :class="b('component-button')"
            :key="`component-icon-${itm.id}`"
            @mousedown="(e) => { onMouseDown(e, itm, false); }"
          >
            <component-icons :className="b('component-button-icon')" :type="itm.icon" />
            {{itm.text}}
          </div>
        </div>
      </div>
      <div :class="b('editor-work-place')">
        <template v-if="(editContent || {}).id">
          <content-editor
            :data="getEditContentData({
              list: (STYLE_LIST[(editContent || {}).id] || {}).list,
              style: (editContent || {}).style || {},
            })"
            :columnData="getEditContentData({
              list: (STYLE_LIST[(editContent || {}).id] || {}).columnList || [],
              style: getEditColumnStyle() || {},
            })"
            :close="() => { editContent = null }"
            :save="saveNewStyle"
            :withText="
              ['textBlock', 'HeadingBlock', 'ButtonBlock'].includes((editContent || {}).id)
            "
            :startTextValue="(editContent || {}).text"
            :withHref="['ButtonBlock'].includes((editContent || {}).id)"
            :isGenerateLink="['ButtonBlock'].includes((editContent || {}).id)"
            :startHref="(editContent || {}).href"
            :withLinks="['textBlock'].includes((editContent || {}).id)"
            :links="this.getLinks()"
            :constants="this.getConstants()"
          />
        </template>
        <template v-if="editCustomHeader">
          <custom-header-editor
            :content="editCustomHeader"
            :save="saveCustomHeader"
            :close="() => { editCustomHeader = null }"
          />
        </template>
        <template v-if="editCustomFooter">
          <custom-footer-editor
            :content="editCustomFooter"
            :save="saveCustomFooter"
            :close="() => { editCustomFooter = null }"
          />
        </template>
        <template v-if="addFrameIndex !== null">
          <email-frame-selector
            :save="saveFrame"
            :close="closeFrameSelector"
          />
        </template>
        <modal-wrapper v-model:show="isShowPopup" width="600px" >
          <div :class="b('modal-content')">
            <div :class="b('add-content-block')">
              <button
                v-for="(itm) in COMPONENTS"
                :class="b('add-content-btn')"
                :key="`add-component-icon-${itm.id}`"
                type="button"
                @click="() => { addContent(itm) }"
              >
                <component-icons :className="b('add-content-btn-icon')" :type="itm.icon" />
                {{itm.text}}
              </button>
            </div>
          </div>
        </modal-wrapper>
        <div
          :class="b('editor-work-area')"
          v-on:mouseenter="handleAreaMouseEnter"
          v-on:mouseleave="handleAreaMouseLeave"
          v-on:mouseup="onAreaMouseUp"
          v-on:focusin="() => {}"
          v-on:focusout="() => {}"
        >
          <div
            v-for="(section, index) in sections"
            :class="b(
              'editor-area-section',
              { 'with-hover': selectedNewSection }
            )"
            :key="`section-${section.id}`"
            :id="`section-${section.id}`"
            :style="section.style"
            v-on:mouseup="(e) => {
              onSectionMouseUp(e, section);
            }"
          >
            <div
              v-for="(column, i) in section.columns"
              :class="b(
                'editor-area-column'
                , { empty: !content, 'with-hover': selectedNewComponent })
              "
              :key="`column-${section.id}-${column.id}`"
              :style="{...column.style}"
              v-on:mouseup="(e) => {
                onColumnMouseUp(e, section, column);
              }"
            >
              <content-block
                v-if="column.content"
                :content="column.content"
                :framesCount="framesCount"
                :frameIds="frameIds"
                :openModal="openModal"
                :changeFrameCount="changeFrameCount"
                :setFrameIndex="setFrameIndex"
                :changeItemField="changeItemField"
              />
              <a-button
                v-if="!column.content"
                type="primary"
                html-type="button"
                :class="b('add-content-button')"
                @click="() => {setEditColumn(column)}"
              >
                Add content
              </a-button>
              <button
                v-if="![
                  'ImagesBlock',
                  'FramesBlock',
                  'Header',
                  'Footer',
                  'PreFooter',
                  'Icons',
                  'Concierge',
                  'InvoiceBlock',
                  'CustomHeader'
                ].includes((column.content || {}).id)"
                :class="b('column-control-btn')"
                type="button"
                @click="() => { clickEditColumn(column.id, section.id); }"
              >
                <edit-outlined
                  v-if="column.id !== editColumnId"
                  :class="b('column-control-icon')"
                />
                <close-outlined
                  v-if="column.id === editColumnId"
                  :class="b('column-control-icon')"
                />
              </button>
              <button
                v-if="['CustomHeader', 'CustomFooter'].includes((column.content || {}).id)"
                :class="b('column-control-btn')"
                type="button"
                @click="() => { clickEditColumn(column.id, section.id); }"
              >
                <edit-outlined
                  v-if="column.id !== editColumnId"
                  :class="b('column-control-icon')"
                />
                <close-outlined
                  v-if="column.id === editColumnId"
                  :class="b('column-control-icon')"
                />
              </button>
              <template v-if="column.id === editColumnId">
                <a-button
                  :class="b('edit-content-btn')"
                  type="primary"
                  size="small"
                  @click="onClickEditContent"
                >
                  ✏️ Edit content
                </a-button>
                <div
                  :class="b('column-size-btn', { left: true })"
                  v-if="i !== 0"
                  v-on:mousedown="() => { setEditXStatus('left') }"
                >
                  <left-outlined :class="b('arrow', { left: true })" />
                </div>
                <div
                  :class="b('column-size-btn', { down: true })"
                  v-on:mousedown="setEditYStatus"
                >
                  <down-outlined :class="b('arrow', { down: true })" />
                </div>
                <div
                  :class="b('column-size-btn', { right: true })"
                  v-if="i < section.columns - 1"
                  v-on:mousedown="() => { setEditXStatus('right') } "
                >
                  <right-outlined :class="b('arrow', { right: true })" />
                </div>
              </template>
            </div>
            <div :class="b('section-controls')">
              <div :class="b('control-column')">
                <button
                  :class="b('section-control-btn')"
                  type="button"
                  @click="() => { deleteSection(section.id); }"
                >
                  <delete-outlined :class="b('delete-icon')" />
                </button>
                <button
                  v-if="checkIsShowCopy(section.columns)"
                  :class="b('section-control-btn')"
                  type="button"
                  @click="() => { copySection(section.id); }"
                >
                  <copy-outlined :class="b('delete-icon')" />
                </button>
              </div>
              <div
                v-if="index !== 0 || index < sections.length - 1"
                :class="b('control-column')"
              >
                <button
                  v-if="index !== 0"
                  :class="b('section-control-btn')"
                  type="button"
                  @click="() => { moveSectionUp(section, index) }"
                >
                  <up-outlined :class="b('arrow', { up: true })" />
                </button>
                <button
                  v-if="index < sections.length - 1"
                  :class="b('section-control-btn')"
                  type="button"
                  @click="() => { moveSectionDown(section, index) }"
                >
                  <down-outlined :class="b('arrow', { down: true })" />
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./emailsEditor.scss" scoped lang="scss"></style>
